import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cake } from "@phosphor-icons/react";
import api from "../lib/api";

export default function AnniversaryCard() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/anniversaries").then((r) => setItems(r.data.anniversaries || [])).catch(() => setItems([]));
  }, []);

  if (!items) return null;

  return (
    <div className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-testid="anniversary-card">
      <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-stone-500">
        <Cake size={14} className="text-[#B7791F]" /> Work anniversaries
      </p>
      <p className="mt-0.5 text-[11px] text-stone-400">Last 14 days + next 30 — print a Years of Service badge from their profile.</p>
      <ul className="mt-2 max-h-40 space-y-1.5 overflow-y-auto">
        {items.map((a) => (
          <li key={a.user_id} className="flex items-baseline justify-between gap-2" data-testid={`anniversary-${a.user_id}`}>
            <Link to={`/team/${a.user_id}`} className="text-sm font-medium text-stone-800 hover:text-primary hover:underline">{a.name}</Link>
            <span className={`shrink-0 text-[10px] font-semibold ${a.crossed ? "text-[#8a5d14]" : "text-stone-500"}`}>
              {a.years} yr{a.years > 1 ? "s" : ""} · {a.date.slice(5).replace("-", "/")}{a.crossed ? " · just passed" : ""}
            </span>
          </li>
        ))}
        {!items.length && <li className="text-xs text-stone-400">None coming up.</li>}
      </ul>
    </div>
  );
}
